import React from 'react'
import { Icon } from 'react-icons-kit'
import { image } from 'react-icons-kit/ionicons'
import { withFileInput } from '../../../modules/file-input/index'

const FileUploadBox = ({ label, file, ...props }) => (
  <div className="file has-name is-boxed">
    <label className="file-label">
      <input className="file-input" type="file" {...props} />
      <span className="file-cta">
        <Icon icon={image} size={24} />
        <span className="file-label">{label}</span>
      </span>
      {file && <span className="file-name">{file.name}</span>}
    </label>
  </div>
)

export default withFileInput(FileUploadBox)



// WEBPACK FOOTER //
// ./src/components/views/widgets/FileUploadBox.js